import { render, staticRenderFns } from "./AIChatWidgetActionButtons.vue?vue&type=template&id=4e897f24&scoped=true"
import script from "./AIChatWidgetActionButtons.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetActionButtons.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetActionButtons.vue?vue&type=style&index=0&id=4e897f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e897f24",
  null
  
)

export default component.exports